import React from 'react';
import { withTheme } from 'styled-components';
export var PlaceholderIcon = function PlaceholderIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "66",
    height: "64",
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: "#F0F6FF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 15C46.692 15 47.3241 15.4112 47.6304 16.0607L52.8259 27.077L64.4447 28.8544C65.1294 28.9592 65.6979 29.4616 65.9113 30.1505C66.1247 30.8393 65.946 31.5953 65.4504 32.1006L57.0446 40.6696L59.0283 52.7754C59.1453 53.4893 58.8649 54.2109 58.3049 54.6366C57.745 55.0624 57.0026 55.1185 56.3901 54.7813L46 49.0625L35.6099 54.7813C34.9974 55.1185 34.255 55.0624 33.6951 54.6366C33.1351 54.2109 32.8547 53.4893 32.9717 52.7754L34.9554 40.6696L26.5496 32.1006C26.054 31.5953 25.8753 30.8393 26.0887 30.1505C26.3021 29.4616 26.8706 28.9592 27.5553 28.8544L39.1741 27.077L44.3696 16.0607C44.6759 15.4112 45.308 15 46 15ZM46 21.2022L42.0122 29.6577C41.7476 30.2188 41.2363 30.6079 40.6448 30.6984L31.7244 32.063L38.1777 38.6416C38.6066 39.0787 38.8023 39.7089 38.7011 40.3264L37.1785 49.6178L45.1537 45.2282C45.6835 44.9366 46.3165 44.9366 46.8463 45.2282L54.8215 49.6178L53.2989 40.3264C53.1977 39.7089 53.3934 39.0787 53.8223 38.6416L60.2756 32.063L51.3552 30.6984C50.7637 30.6079 50.2524 30.2188 49.9878 29.6577L46 21.2022Z",
    fill: theme.colors.primary
  }));
};
export var PlaceholderReviewsIcon = withTheme(PlaceholderIcon);